export const COLUMN_NAME_MAPPING: { [k: string]: string } = {
    coId: 'Company ID',
    contractMultiplier: 'Contract Unit',
    country: 'Domicile Country',
    coupon: 'Coupon Rate',
    description: 'Security Description',
    gicsCode: 'Global Industry Classification Code',
    gicsIndustry: 'Industry',
    gicsSector: 'Industry Sector',
    isin: 'ISIN',
    mic: 'Market ID Code',
    minTick: 'Minimum Tick Size',
    ndvrChainId: 'NDVR Chain ID',
    primaryExchange: 'Exchange',
    putCall: 'Option Type',
    scId: 'Share Class ID',
    sId: 'Security ID',
    length: 'Years to Maturity',
    aC: 'Account ID',
    brokerId: 'Broker ID',
    nav: 'NAV',
    pId: 'Portfolio ID',
    portfolioGuid: 'Portfolio GUID',
    vixClosePrice: 'VIX Close Price',
    vixGrossExposure: 'VIX Gross Exposure',
    vixNetExposure: 'VIX Net Exposure',
    vixCurrentContractsNumber: 'VIX Current Contracts Number',
    vixTargetContractsNumber: 'VIX Target Contracts Number',
    vixActiveContractsNumber: 'VIX Active Contracts Number',
    vixExposureType: 'VIX Exposure Type',
    bfTargetExposure: 'Bond Futures Target Exposure',
    bfActiveExposure: 'Bond Futures Active Exposure',
    bfTargetQuantity: 'Bond Futures Target Quantity',
    bfActiveQuantity: 'Bond Futures Active Quantity',
    marketValuePercentOfNav: 'Market Value Percent Of NAV',
    optimizationId: 'Optimization ID',
    startTimeEst: 'Start Time EST',
    completionTimeEst: 'Completion Time EST',
    initialMarginPerContract: 'Initial Margin per Contract',
    rebalancePlanGuid: 'Rebalance Plan GUID',
    orderId: 'Order ID',
    isSuspended: 'Suspended (Snapshot)',
    suspendedAt: 'Suspended At (Live)',
    isOnboarded: 'Onboarded',
    isMirrorLinked: 'Mirror Linked',
    isTaxLossHarvesting: 'Tax Loss Harvesting',
    isClientDirected: 'Client Directed',
    isCashOnly: 'Cash Only',
    isTestAccount: 'Test Account',
    isUniverseAccount: 'Universe Account',
    ndvrPortfolioType: 'NDVR Portfolio Type',
    isTaxable: 'Taxable',
    isDirectStock: 'Direct Stock',
    isGlobalBeta: 'Global Beta',
    isPaydayBond: 'Payday Bond',
    isGrowthBond: 'Growth Bond',
    isBondFutures: 'Bond Futures',
    isBondFuturesOption: 'Bond Futures Option',
    isVix: 'VIX',
    isHedgedEquity: 'Hedged Equity',
    isShortTermTreasury: 'Short Term Treasury',
    totalSeconds: 'Total',
    targetQuantityDiv: 'target_quantity_div??',
    vixScalingFactor: 'VIX Scaling Factor',
    ndvrTradeId: 'NDVR Trade ID',
    isLiveHeld: 'Live Held',
    factorGuid: 'Factor GUID',
    algoId: 'Algo ID',
    totalQuantity: 'Number of shares',
    totalValue: 'Total trade value',
    percentOfNav: '% of NAV',
    tradesCount: 'Number of trades',
    totalNav: 'Total NAV',
    isActive: 'Active',
    targetEquityValueUsa: 'Target Equity Value USA',
    numFactors: 'Number of Factors',
    pnlUnrealized: 'Unrealized PnL',
    pnlRealized: 'Realized PnL',
    pnlUnrealizedType: 'PnL Unrealized Type',
    targetEquityWeightEmg: 'Target Equity Weight EMG',
    minSellEmg: 'Min Sell EMG',
    maxBuyEmg: 'Max Buy EMG',
    targetEquityWeightUs: 'Target Equity Weight US',
    minSellUs: 'Min Sell US',
    maxBuyUs: 'Max Buy US',
    targetEquityWeightDev: 'Target Equity Weight DEV',
    minSellDev: 'Min Sell DEV',
    maxBuyDev: 'Max Buy DEV',
    isCashTransaction: 'Cash Transaction',
};
